/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import _ from 'lodash';
import { BalanceStatus, BalanceType } from 'constants/balance.constants';
import { Box, Switch, useTheme, Stack, Typography } from '@mui/material';
import { formatDate, formatNumber, generalTranslation } from 'constants/global.constants';
import { tableColumns } from './tables.types';
import { CustomSwitch } from 'components/Inputs';
import { updateCompanyBenefitStatus } from 'services/benefits.service';

export const tableData = (data: any) => {
	return data?.map((item: any) => ({
		name: item?.benefit?.name,
		createdBy: item?.createdByBoUser?.firstName + ' ' + item?.createdByBoUser?.lastName,
		...item,
	}));
};

export const buildColumns = (t: any, dispatch: any, canCreateBenefit: boolean): columnType[] => {
	const theme = useTheme();
	const columns: columnType[] = [];

	_.keys(tableColumns).map((element: any, index: number) => {
		let customValueHandle = {};

		if (element === 'isActive') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack display="flex" direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch checked={value} theme={theme}>
								<Switch
									checked={value}
									disabled={!canCreateBenefit || !row?.isActive}
									onChange={() => {
										if (canCreateBenefit) {
											dispatch(updateCompanyBenefitStatus(row.id, row.companyId, false));
										}
									}}
								/>
							</CustomSwitch>
						</Stack>
					);
				},
			};
		}
		if (element === 'createdAt') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return <Typography variant="body2">{formatDate(value)}</Typography>;
				},
			};
		}

		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.customerAccounts.tables.companyBenefits.field.' + element),
			type: tableColumns[element],
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});

	return columns;
};
